import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "@/components/Landing";
import PeaceProject from "@/components/PeaceProject";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/the-peace-project" element={<PeaceProject />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
